export default __webpack_public_path__ + "static/assets/355ba2dbdbde4c71b30f18f0764a2db1.png";